import template from './control.html';

/** @ngInject */
function controlConfig($stateProvider, modulesProvider) {
  modulesProvider.registerModule({
    title: 'Kontrola',
    state: 'modules.control.realizations',
    showInMenu: true,
    permissions: ['ALL']
  });

  $stateProvider
    .state('modules.control', {
      url: '/control',
      abstract: true,
      views: {
        'content@': {
          template,
          controller: 'ControlController as ctrl'
        }
      }
    })
    .state('modules.control.realizations', {
      url: '/realizations',
      views: {
        'control@modules.control': {
          component: 'controlRealizationsComponent'
        }
      },
      resolve: {
        employees: EmployeeService => EmployeeService.getEmployeesWithoutSupply()
      }
    })
    .state('modules.control.workedHours', {
      url: '/workedHours',
      views: {
        'control@modules.control': {
          component: 'controlWorkedHoursComponent'
        }
      },
      resolve: {
        employees: EmployeeService => EmployeeService.getEmployeesWithoutSupply()
      }
    });
}

export default controlConfig;
